module.exports = __webpack_public_path__ + "img/menu_01.70e1c6b.svg";